import {createTheme} from '@mui/material';

const theme = createTheme({
  components: {
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
      },
    },
  },
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
    h4: {
      fontWeight: 700,
    },
    subtitle0: {
      fontFamily: ['Poppins', 'sans-serif'].join(','),
      fontSize: '1rem',
      fontWeight: 500,
    },
    // metricName: {},
    // metricNumber: {},
    dashboardTitle: {
      fontFamily: ['Poppins', 'sans-serif'].join(','),
      fontWeight: 700,
      fontSize: 20,
      lineHeight: '30px',
    },
    metricUnit: {
      fontFamily: ['Poppins', 'sans-serif'].join(','),
      fontSize: 12,
      textAlign: 'center',
      fontWeight: 600,
    },
    metricGroupTitle: {
      fontFamily: ['Poppins', 'sans-serif'].join(','),
      fontSize: 24,
      fontWeight: 600,
    },
  },
  palette: {
    primary: {
      main: '#35C6C9',
    },
    atp: {
      main: '#ee5c36',
    },
    doktor: {
      main: '#0633CB',
    },
    hellohealth: {
      main: '#F5733B',
    },
    external: {
      main: '#204AF5',
    },
    grayscale: {
      main: '#EEEEEE',
      dark: '#CCCCCC',
      light: '#f9f9f9',
    },
    neutral: {
      main: '#ffffff',
      contrastText: '#ffffff',
    },
    grayvitals: {
      main: 'rgba(0,0,0,0.3)',
    },
    graydetailsselected: {
      main: 'rgba(217,217,217,0.6)',
    },
    graydetailsnotselected: {
      main: 'rgba(217,217,217,0.25)',
    },
  },
});

theme.typography.metricName = {
  fontFamily: ['Poppins', 'sans-serif'].join(','),
  fontSize: 20,
  fontWeight: 700,
  [theme.breakpoints.down('lg')]: {
    fontSize: 17,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 15,
  },
  '@media (max-width:375px)': {
    fontSize: 14,
  },
};

theme.typography.metricLittleText = {
  fontFamily: ['Poppins', 'sans-serif'].join(','),
  fontSize: 15,
  [theme.breakpoints.down('sm')]: {
    fontSize: 12,
  },
  '@media (max-width:375px)': {
    fontSize: 11,
  },
  fontWeight: 700,
};

theme.typography.metricNumber = {
  fontFamily: ['Poppins', 'sans-serif'].join(','),
  fontSize: 25,
  fontWeight: 700,
  [theme.breakpoints.down('sm')]: {
    fontSize: 22,
  },
  '@media (max-width:375px)': {
    fontSize: 18,
  },
};
theme.typography.metricRangeLabel = {
  fontFamily: ['Poppins', 'sans-serif'].join(','),
  fontSize: 12,
  '@media (max-width:375px)': {
    fontSize: 10,
  },

  fontWeight: 700,
};

export default theme;
